"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeObserver = void 0;
const handleIntersection = (entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add("viewed");
            observer.unobserve(entry.target);
        }
    });
};
const initializeObserver = () => {
    const targetElements = document.querySelectorAll(".inview");
    const observer = new IntersectionObserver(handleIntersection);
    targetElements.forEach((element) => {
        observer.observe(element);
    });
};
exports.initializeObserver = initializeObserver;
